import { SagaIterator } from '@redux-saga/types';
import { all, fork } from 'redux-saga/effects';
import { watchOverLoginRequest } from './authSaga';

export function* rootSaga(): SagaIterator {
  yield all([yield fork(watchOverLoginRequest)]);
}
